// extracted by mini-css-extract-plugin
export default {"root":"styles_root__FBuN0","popup":"styles_popup__w20Du","popup_sameWidth":"styles_popup_sameWidth__xNnMR","ajaxPopup":"styles_ajaxPopup__q4AU-"};